import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/shared/auth/AuthContext";
import { renderPrintDocument, type RenderPrintRequest } from "@/modules/print/api/printApi";

export function usePrintRender(request: RenderPrintRequest | null) {
  const { http } = useAuth();
  return useQuery({
    queryKey: ["print", "render", request],
    queryFn: () => renderPrintDocument(http, request!),
    enabled: Boolean(request?.docCode && request?.entityKey),
    staleTime: 0,
  });
}
